module.exports = __webpack_public_path__ + "static/deploy-dc110ad03ddac5cb17315eb12d348c6a.mp4";